module.exports = "<div class=evtBiblRef compile=vm.getFormattedBibl()> </div> ";